import React, { useEffect, useState } from 'react';
import '../css_mobile/style_login.css'

import mobileBi from "./images/mobile-bi.png";

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
// import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

import idSaveChkBoxOn from '../components/images/idSaveChkbox-on.svg'
import idSaveChkBoxOff from '../components/images/idSaveChkbox-off.svg';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { loginUser } from '../_actions/user_action';
import { setUserAccount, getIsLogin, clearSession } from '../utils/session';

function MobileLogin() {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");

  const [EmailValid, setEmailValid] = useState(false);
  const [PasswordValid, setPasswordValid] = useState(false);
  const [NotAllow, setNotAllow] = useState(true);

  // 2024-12-31 SEMIQUZ
  const [username, setUsername] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    const savedUsername = localStorage.getItem('savedUsername');
    if (savedUsername) {
      setEmail(savedUsername);
      setUsername(savedUsername);
      setRememberMe(true);
      const regex =
        /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
      if (regex.test(savedUsername)) {
        setEmailValid(true);
      } else {
        setEmailValid(false);
      }
    }
  }, []);

  const handleCheckboxClick = () => {
    setRememberMe(!rememberMe);
  };

  const info = require('../config/info');

  const onEmailHandler = (event) => {
    setEmail(event.target.value);
    // 2024-12-31 SEMIQUZ
    setUsername(event.target.value);

    const regex =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    if (regex.test(event.target.value)) {
      setEmailValid(true);
    } else {
      setEmailValid(false);
    }
  };

  const onPasswordHandler = (event) => {
    setPassword(event.target.value);

    const regex =
      /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+])(?!.*[^a-zA-z0-9$`~!@$!%*#^?&\\(\\)\-_=+]).{8,20}$/;
    if (regex.test(event.target.value)) {
      setPasswordValid(true);
    } else {
      setPasswordValid(false);
    }
  };
  
  const onSubmitHandler = (event) => {
    event.preventDefault();
    console.log('onSubmitHandler');

    if (rememberMe) {
      localStorage.setItem('savedUsername', username);
      console.log('setItem - savedUsername: ', username);
    } else {
      localStorage.removeItem('savedUsername');
      console.log('removeItem - savedUsername: ');
    }

    console.log('Email', Email);
    console.log('Password', Password);

    // 이전 세션 잔재를 확실히 지운 뒤 새 로그인 시도를 시작한다.
    clearSession();

    let body = {
      email: Email,
      password: Password
    }

    dispatch(loginUser(body))
    .then(response => {
      if (response.payload.loginSuccess) {
        setUserAccount(response.payload.userAccount);
        window.location.replace('/mobile/home');
      } else {
        let msgAlert = response.payload.message;
        if (msgAlert.length > 1) {
          alert(msgAlert);
        } else {
          alert('등록되지 않은 [EMS 회원] 입니다.');
        }
      }
    }).catch((err) => console.log(err));
  }

  useEffect (() => {
    if (EmailValid && PasswordValid) {
      setNotAllow(false);
      return;
    }
    setNotAllow(true);
  }, [EmailValid, PasswordValid]);

  const isLogin = getIsLogin();

  useEffect(() => {
      if (isLogin) {
        navigate('/mobile/home');
        return;
      }
  }, [isLogin, navigate]);

  // 2023-02-27 아이디 비빌번호 Input
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  }

  return (
    <div className="login">
      <div className="mobile-header">
        <img className="mobile-bi" alt="Mobile bi" src={mobileBi} />
        {/* <img
          className="huge-icon-menu-solid"
          alt="Huge icon menu solid"
          src={menuUser}
        /> */}
      </div>

      <div className="mobile-loginbody">
        <div className="mobile-container">
          <div className="div">
            <div className="login-title">
              <div className="text-wrapper-2">EMS 환경 측정 시스템</div>
              <div className="text-wrapper-3">
                Environment Measurement System
              </div>
            </div>

            <div className="login-body">
              <div className="login-write">
                <div className="div-2">
                  <div className="frame-2">
                    <div className="text-wrapper-4">아이디</div>
                    <div className="text-wrapper-5">*</div>
                  </div>
                  <FormControl sx={{ width: '100%' }} variant="outlined">
                    <OutlinedInput
                      style={{ border: '2px', borderRadius: '8px', marginTop: '0px', height: '60px' }}
                      type="text"
                      placeholder='아이디를 입력해주세요'
                      value={username}
                      onChange={onEmailHandler}
                      endAdornment={
                        <InputAdornment position="end">
                          {/* <IconButton
                            arial-label="toggle admin login"
                            onClick={handleClickIsLoginAdmin}
                            onMouseDown={handleMouseDownIsLoginAdmin}
                            edge="end"
                          >
                            <AdminPanelSettingsIcon />
                          </IconButton> */}
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  {/* <div className="login-error-message">
                    {!EmailValid && Email.length > 0 && (
                      // <div>올바른 이메일을 입력해주세요.</div>
                      <div>올바른 아이디를 입력해주세요.</div>
                    )}
                  </div> */}
                </div>

                <div className="div-2">
                  <div className="frame-2">
                    <div className="text-wrapper-4">비밀번호</div>
                    <div className="text-wrapper-5">*</div>
                  </div>
                  <FormControl sx={{ width: '100%' }} variant="outlined">
                    <OutlinedInput
                      style={{ border: '2px', borderRadius: '8px', marginTop: '0px', height: '60px' }}
                      id="outlined-adornment-password"
                      type={showPassword ? 'text' : 'password'}
                      placeholder='비밀번호를 입력해주세요'
                      value={Password}
                      onChange={onPasswordHandler}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            arial-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  {/* <div className="login-error-message">
                    {!PasswordValid && Password.length > 0 && (
                      <div>올바른 비밀번호를 입력해주세요.</div>
                    )}
                  </div> */}
                </div>

                <div className="save-id">
                  <div className="frame-3" onClick={handleCheckboxClick}>
                    <img
                      src={rememberMe ? idSaveChkBoxOn : idSaveChkBoxOff}
                      alt="아이디 저장 체크박스"
                      style={{ width: '32px', height: '32px', marginRight: '0px' }}
                    />
                    <div className="login-to-account">아이디 저장</div>
                  </div>
                </div>
              </div>

              <button onClick={onSubmitHandler} disabled={NotAllow} className="loginButton">로그인</button>
            </div>
          </div>

          <p className="p">© 2025 SEMIQUZ. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default MobileLogin;
